module.exports = __webpack_public_path__ + "img/caret_up.67f9710f.svg";